module.exports = __webpack_public_path__ + "static/media/Diorama.0001-nosprite.37719f57.png";